import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useRouter } from 'next/navigation'
import { useTranslation } from '@/localization/useTranslation'

import classes from './styles.module.scss'
import { useQueryState } from 'nuqs'
import { NAVBAR_THEMES } from '@/constants'

interface MinimalNavbarProps {
  icon?: IconDefinition
  label?: string
  onClick?: () => void
}

export const MinimalNavbar = (props: MinimalNavbarProps) => {
  const { icon, label, onClick } = props
  const { t } = useTranslation()
  const router = useRouter()
  const [authFormType] = useQueryState('form')
  const themeType = (authFormType || 'default') as keyof typeof NAVBAR_THEMES
  const theme = NAVBAR_THEMES[themeType] || NAVBAR_THEMES.default

  const handleBackToHome = () => {
    if (onClick) {
      onClick()
      return
    }

    router.push('/')
  }

  return (
    <nav className={classes.minimal_navbar} style={{ backgroundColor: theme.backgroundColor }}>
      <div className={classes.item} onClick={handleBackToHome}>
        <FontAwesomeIcon icon={icon || faArrowLeft} />
        <span>{label || t('Back to Home')}</span>
      </div>
    </nav>
  )
}
